import API from '@/api/base'

export const state = {
  locations: [],
  fulfillment: {
    location: {},
    pickupDate: '',
    pickupTime: '',
  },
}

export const getters = {
  getLocations: ({ locations }) => locations,
  getFilteredLocations: ({ locations }) => (filter) => locations,
  getLocationFormField: (state) => (field) => state.fulfillment[field],
  getFulfillment: (state) => {
    const fulfillment = JSON.parse(JSON.stringify(state.fulfillment))
    fulfillment.location = state.fulfillment.location
    fulfillment.pickupDate = state.fulfillment.pickupDate
    fulfillment.pickupTime = state.fulfillment.pickupTime
    fulfillment.method = state.fulfillment.method
    return fulfillment
  },
}

export const actions = {
  fetchLocations: ({ commit }, params) =>
    new Promise((resolve, reject) => {
      const requestParams = {
        query: {
          site_id: params.siteId,
        },
      }
      if (params.fulfillment) {
        requestParams.filter = {
          fulfillment: true,
          with_times: true,
        }
      }
      API.findAll('locations', requestParams)
        .then((response) => {
          commit('SET_LOCATIONS', response.data)
          resolve(response.data)
        })
        .catch((error) => {
          reject(error.response)
        })
    }),
  updateFulfillmentField({ commit }, payload) {
    commit({
      type: 'SET_FULFILLMENT_FIELD',
      field: payload.field,
      value: payload.value,
    })
  },
  // fetchShopItem: ({ commit }, itemId) =>
  //   new Promise((resolve, reject) => {
  //     API.find('shopItem', itemId)
  //       .then((response) => {
  //         // TODO: Add this to the store
  //         resolve(response.data)
  //       })
  //       .catch((error) => {
  //         reject(error.response)
  //       })
  //   }),
}

export const mutations = {
  SET_LOCATIONS(state, locations) {
    state.locations = locations
  },
  SET_FULFILLMENT_FIELD(state, payload) {
    state.fulfillment[payload.field] = payload.value
  },
}
